export default __webpack_public_path__ + "static/media/bf-games.61f1e504.png";